import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import './ReceptionModals.css';

class SetupPinModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pin: '',
            confirmPin: '',
            pinError: '',
            confirmPinError: '',
            isSubmitting: false
        };
    }

    handlePinChange = (e) => {
        const pin = e.target.value;
        if (/^\d{0,4}$/.test(pin)) {
            this.setState({ pin, pinError: pin.length === 4 ? '' : 'PIN must be 4 digits' });
        }
    }

    handleConfirmPinChange = (e) => {
        const confirmPin = e.target.value;
        if (/^\d{0,4}$/.test(confirmPin)) {
            this.setState({ confirmPin, confirmPinError: '' });
        }
    }

    validateForm = () => {
        const { pin, confirmPin } = this.state;
        let isValid = true;
        let pinError = '';
        let confirmPinError = '';

        if (!pin || pin.length !== 4) {
            pinError = 'PIN must be 4 digits';
            isValid = false;
        }
        if (!confirmPin || confirmPin.length !== 4) {
            confirmPinError = 'Confirm PIN must be 4 digits';
            isValid = false;
        } else if (pin !== confirmPin) {
            confirmPinError = 'PINs do not match';
            isValid = false;
        }

        this.setState({ pinError, confirmPinError });
        return isValid;
    }

    handleSubmit = (e) => {
        e.preventDefault();
        if (this.validateForm()) {
            this.setState({ isSubmitting: true });
            this.props.onSetupPin(this.state.pin);
        }
    }

    render() {
        const { onClose } = this.props;
        const { pin, confirmPin, pinError, confirmPinError, isSubmitting } = this.state;

        return ReactDOM.createPortal(
            <div className="rm-modal-overlay" onClick={onClose}>
                <div className="rm-modal" onClick={(e) => e.stopPropagation()}>
                    <div className="rm-modal-header">
                        <h3>Choose a PIN</h3>
                        <button className="rm-modal-close" onClick={onClose} type="button">&times;</button>
                    </div>
                    <div className="rm-modal-body">
                        <p>Choose a 4-digit PIN. This device then locks: it can only do what the Front desk role allows until someone enters the PIN.</p>
                        <form onSubmit={this.handleSubmit}>
                            <div className="rm-form-group">
                                <label className="rm-label" htmlFor="pin">Enter 4-digit PIN</label>
                                <input
                                    type="password"
                                    className={`rm-input${pinError ? ' rm-input--error' : ''}`}
                                    id="pin"
                                    value={pin}
                                    onChange={this.handlePinChange}
                                    placeholder="Enter 4-digit PIN"
                                    maxLength={4}
                                    autoComplete="new-password"
                                    disabled={isSubmitting}
                                    autoFocus
                                />
                                {pinError && <span className="rm-error">{pinError}</span>}
                            </div>
                            <div className="rm-form-group">
                                <label className="rm-label" htmlFor="confirmPin">Confirm 4-digit PIN</label>
                                <input
                                    type="password"
                                    className={`rm-input${confirmPinError ? ' rm-input--error' : ''}`}
                                    id="confirmPin"
                                    value={confirmPin}
                                    onChange={this.handleConfirmPinChange}
                                    placeholder="Confirm 4-digit PIN"
                                    maxLength={4}
                                    autoComplete="new-password"
                                    disabled={isSubmitting}
                                />
                                {confirmPinError && <span className="rm-error">{confirmPinError}</span>}
                            </div>
                            <p className="rm-hint">You will need this PIN to unlock. If you forget it, reset it with your account password.</p>
                            <div className="rm-modal-footer">
                                <button
                                    type="button"
                                    className="rm-btn rm-btn--secondary"
                                    onClick={onClose}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="rm-btn rm-btn--primary"
                                    disabled={isSubmitting}
                                >
                                    {isSubmitting ? 'Setting up...' : 'Continue'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>,
            document.body
        );
    }
}

export default SetupPinModal;
